import Full from '@/containers/Full';

/**
 * 路由path -> 组件的映射表
 * 新增页面时在此注册
 */
export const componentMap = {
  // 首页
  '/admin/home': require('@/views/JsonTree.vue').default,

  // 魔鬼城
  '/mgc/mgcmanage': require('@/views/mgc/mgcmanage').default,
  '/mgc/xntgmanage': require('@/views/mgc/xntgmanage').default,

  // 推币机
  '/tuibi/coinmanage': require('@/views/tuibi/coinmanage').default,
  '/tuibi/jpreward': require('@/views/tuibi/jpreward').default,

  // 娃娃机
  '/wawa/wawamanage': require('@/views/wawa/wawamanage').default,

  // 用户管理
  '/user/usermanage': require('@/views/user/usermanage').default,
  '/user/rechargecheck': require('@/views/user/rechargecheck').default,
  '/user/rechangRank': require('@/views/user/rechangRank').default,
  '/user/consumeRank': require('@/views/user/consumeRank').default,

  // 商品库
  '/spk/spklist': require('@/views/spk/spklist').default,

  // 商城
  '/shopmanage/shoplist': require('@/views/shopmanage/shoplist').default,
  '/shopmanage/inventorywarning': require('@/views/shopmanage/inventorywarning').default,

  // 发货
  '/fahuo/fahuolist': require('@/views/fahuo/fahuolist').default,
  '/fahuo/yifahuolist': require('@/views/fahuo/yifahuolist').default,

  // 财务
  '/finance/wawalist': require('@/views/finance/wawalist').default,
  '/finance/coinlist': require('@/views/finance/coinlist').default,
  '/finance/realtimecoinlist': require('@/views/finance/realtimeCoinlist').default,
  '/finance/mgclist': require('@/views/finance/mgclist').default,
  '/finance/candylist': require('@/views/finance/candylist').default,
  '/finance/rechangelist': require('@/views/finance/rechangelist').default,

  // 每日统计
  '/daycensus/userlist': require('@/views/daycensus/userlist').default,
  '/daycensus/rechangelist': require('@/views/daycensus/rechangelist').default,
  '/daycensus/coinlist': require('@/views/daycensus/coinlist').default,
  '/daycensus/integrlist': require('@/views/daycensus/integrlist').default,
  '/daycensus/attributionlist': require('@/views/daycensus/attributionlist').default,

  // 运营管理
  '/yymanage/personlist': require('@/views/yymanage/personlist').default,
  '/yymanage/versionlist': require('@/views/yymanage/versionlist').default,
  '/yymanage/bannerlist': require('@/views/yymanage/bannerlist').default,
  '/yymanage/zhubolist': require('@/views/yymanage/zhubolist').default,
  '/yymanage/showlist': require('@/views/yymanage/showlist').default,

  // 机器报警
  '/machinewring/machinealarm': require('@/views/wring/machinewring').default,
  '/machinewring/armonile': require('@/views/wring/armonile').default,

  // 系统管理
  '/sysmanage/sysuser': require('@/views/sysmanage/sysuser').default,
  '/sysmanage/role': require('@/views/sysmanage/role').default,
  '/sysmanage/menu': require('@/views/sysmanage/menu').default,
};

/**
 * 将菜单列表（平铺数组）构建成 Vue Router 路由配置
 * 结构：一个 Full 容器，首页 + 各顶级菜单作为 children
 */
export function buildRoutesFromMenus(menus) {
  const topMenus = menus.filter(m => Number(m.parent_id) === 0).sort((a, b) => a.sort - b.sort);

  // 首页固定子路由
  const children = [
    {
      path: '/home/index',
      name: '首页',
      icon: 'merge',
      component: require('@/views/JsonTree.vue').default,
    }
  ];

  topMenus.forEach(top => {
    const subMenus = menus
      .filter(m => Number(m.parent_id) === Number(top.id))
      .sort((a, b) => a.sort - b.sort);

    if (subMenus.length === 0) return;

    const firstChildPath = subMenus[0].path;

    children.push({
      path: top.path,
      name: top.menu_name,
      icon: top.icon,
      hidden: top.hidden === 1,
      redirect: firstChildPath,
      component: { render: c => c('router-view') },
      children: subMenus.map(child => ({
        path: child.path.replace(top.path + '/', ''), // 相对路径
        name: child.menu_name,
        icon: child.icon,
        hidden: child.hidden === 1,
        component: componentMap[child.path] || { render: c => c('div', ['页面组件未注册: ' + child.path]) },
      }))
    });
  });

  const firstMenuPath = topMenus.length > 0
    ? menus.filter(m => m.parent_id === topMenus[0].id).sort((a, b) => a.sort - b.sort)[0]?.path || '/home/index'
    : '/home/index';

  return [{
    path: '/main',
    component: Full,
    name: '主布局',
    redirect: firstMenuPath,
    children,
  }];
}
